import { svg } from 'lit';
export const minus24Svg = svg `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M6 12H18" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

`;
//# sourceMappingURL=minus_24.svg.js.map